import {
	TreeExtension,
	TreeFileExtension,
	TreeFolderExtension,
	TreeFolderNameExtension,
} from "@productlane/lib/src/tiptap/extensions/mintlify/tree"

// The width of the folder icon plus its gap, measured from the row's padding.
const ICON_HIT_WIDTH = 22

// A real <details> collapses and toggles itself inside the editor, which hides
// the files being edited and fights ProseMirror over the `open` attribute.
const TreeFolderInEditor = TreeFolderExtension.extend({
	addNodeView() {
		return ({ node }) => {
			const dom = document.createElement("div")
			dom.setAttribute("data-type", "tree-folder")
			dom.className = "pl-tree-folder"
			dom.setAttribute("data-open", String(Boolean(node.attrs.open)))
			return {
				dom,
				contentDOM: dom,
				update: (next) => {
					if (next.type !== node.type) return false
					dom.setAttribute("data-open", String(Boolean(next.attrs.open)))
					return true
				},
			}
		}
	},
})

// The folder icon is the toggle for "open by default", the rest of the row is text.
const TreeFolderNameInEditor = TreeFolderNameExtension.extend({
	addNodeView() {
		return ({ editor, getPos }) => {
			const dom = document.createElement("div")
			dom.setAttribute("data-type", "tree-name")
			dom.className = "pl-tree-name"
			dom.addEventListener("mousedown", (event) => {
				if (event.button !== 0 || typeof getPos !== "function") return
				const rect = dom.getBoundingClientRect()
				const padding =
					Number.parseFloat(getComputedStyle(dom).paddingLeft) || 0
				const iconStart = padding - ICON_HIT_WIDTH
				const x = event.clientX - rect.left
				if (x < iconStart || x > padding) return
				const pos = getPos()
				if (pos === undefined) return
				event.preventDefault()
				const $pos = editor.state.doc.resolve(pos)
				editor.commands.toggleTreeFolder($pos.before($pos.depth))
			})
			return { dom, contentDOM: dom }
		}
	},
})

export const TreeWithNodeView = [
	TreeExtension,
	TreeFolderInEditor,
	TreeFolderNameInEditor,
	TreeFileExtension,
]
